import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import CountdownBand from "@/components/site/CountdownBand";
import WhyJovino from "@/components/site/WhyJovino";
import TokenSpecs from "@/components/site/TokenSpecs";
import FixedSupply from "@/components/site/FixedSupply";
import Tokenomics from "@/components/site/Tokenomics";
import Vesting from "@/components/site/Vesting";
import Utility from "@/components/site/Utility";
import Staking from "@/components/site/Staking";
import Ecosystem from "@/components/site/Ecosystem";
import BuybackBurn from "@/components/site/BuybackBurn";
import Governance from "@/components/site/Governance";
import Security from "@/components/site/Security";
import Roadmap from "@/components/site/Roadmap";
import Interoperability from "@/components/site/Interoperability";
import Vision from "@/components/site/Vision";
import Presale from "@/components/site/Presale";
import WhitepaperSection from "@/components/site/WhitepaperSection";
import Faq from "@/components/site/Faq";
import Legal from "@/components/site/Legal";
import Footer from "@/components/site/Footer";

const Home = () => (
  <div className="bg-navy min-h-screen" data-testid="home-page">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <CountdownBand />
      <WhyJovino />
      <TokenSpecs />
      <FixedSupply />
      <Tokenomics />
      <Vesting />
      <Utility />
      <Staking />
      <Ecosystem />
      <BuybackBurn />
      <Governance />
      <Security />
      <Roadmap />
      <Interoperability />
      <Vision />
      <Presale />
      <WhitepaperSection />
      <Faq />
      <Legal />
    </main>
    <Footer />
  </div>
);

export default Home;
